module.exports = __webpack_public_path__ + "img/mine.9cea5bfa.jpg";